// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Post_wrapper__3E4Mj","text":"Post_text__1rFw5","content":"Post_content__3BLaS","stats":"Post_stats__1aNVW","likesNum":"Post_likesNum__1q8iK"};